import { createAction, props } from '@ngrx/store';
import { IEmploymentData, IEmploymentModel } from '@partners/api';

export class EmploymentActions {
  static reset = createAction('[Employment] Reset State');
  static updateModel = createAction('[Employment] Update Model', props<{ model: IEmploymentModel }>());
  static load = createAction('[Employment] Load');
  static loadSuccess = createAction(
    '[Employment] Load Success',
    props<{ model: IEmploymentModel; data: IEmploymentData }>()
  );
  static loadFailure = createAction('[Employment] Load Failure', props<{ error: any }>());
  static submit = createAction('[Employment] Submit');
  static submitSuccess = createAction('[Employment] Submit Success', props<{ model: IEmploymentModel, data: IEmploymentData }>());
  static submitFailure = createAction('[Employment] Submit Failure', props<{ error: any }>());
}
